<p-dialog
  *ngIf="visible"
  [header]="header"
  [style]="{ width: '750px', height: '450px' }"
  [(visible)]="visible"
  modal="modal"
  [closeOnEscape]="false"
  [focusOnShow]="false"
  appendTo="body"
  [resizable]="false"
  [closable]="false"
  styleClass="wizard__dialog"
>
  <kpd-action class="wizard__dialog-close" icon="times" [disable]="importLoading" (action)="close(true)"></kpd-action>
  <kpd-wizard [title]="'Import permissions' | translate" [activeStep]="activeStep" class="permission-import">
    <kpd-wizard-step [header]="'Choose import type' | translate">
      <form>
        <div class="flex-row flex-wrap form--no-margin-right">
          <div class="flex-column form__column">
            <div class="form__control flex-row">
              <label>{{ 'Import type' | translate }}:</label>
              <div class="form__input">
                <p-dropdown [options]="types" [(ngModel)]="selectedType" name="type"></p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </form>
      <ng-template kpdTemplate="footer">
        <button class="button button--outline" (click)="close()" translate>Cancel</button>
        <button class="button button--main" (click)="onConfirmType()" translate>Next</button>
      </ng-template>
    </kpd-wizard-step>
    <kpd-wizard-step [header]="'Select template' | translate">
      <div class="permissionset-import full-height" *ngIf="permissionSetLoading">
        <div class="spinner__icon spinner__icon--small">
          <kpd-spinner type="overlay"></kpd-spinner>
        </div>
      </div>
      <p-table
        *ngIf="!permissionSetLoading"
        class="dialog__table table__fullheight"
        dataKey="key"
        [value]="permissionSets"
        [(selection)]="selectedPermissionSet"
        selectionMode="single"
        [responsive]="true"
        [scrollable]="true"
        scrollHeight="60vh"
        [columns]="permissionSetsColumns"
      >
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" translate>No templates found</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <col *ngFor="let col of columns" [style.width]="col.width" />
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
              {{ col.header }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
          <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
            <td *ngFor="let col of columns">
              <label *ngIf="!col.type">{{ rowData[col.field] }}</label>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <ng-template kpdTemplate="footer">
        <button class="button button--outline" (click)="close()" translate>Cancel</button>
        <button
          class="button button--main"
          (click)="onConfirmPermissionSet()"
          [disabled]="!selectedPermissionSet"
          translate
        >
          Next
        </button>
      </ng-template>
    </kpd-wizard-step>
    <kpd-wizard-step [header]="'Confirm changes' | translate">
      <!-- <div *ngIf="changedPermissions.delete.length === 0 && changedPermissions.add.length === 0" translate>
        No permissions found to update
      </div> -->
      <div class="nochanges" *ngIf="changedPermissions.delete.length === 0 && changedPermissions.add.length === 0">
        <span>¯\_(ツ)_/¯</span>
        <p translate>No permissions found to update</p>
      </div>
      <kpd-collapse-panel
        title="{{ 'Permissions to remove' | translate }}"
        *ngIf="changedPermissions.delete.length > 0"
      >
        <p-table
          class="dialog__table"
          dataKey="key"
          [value]="changedPermissions.delete"
          [responsive]="true"
          [columns]="verifyColumns"
        >
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" translate>No permissions found</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
              <col *ngFor="let col of columns" [style.width]="col.width" />
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th width="30px">
                <input
                  type="checkbox"
                  [checked]="changedPermissions.delete.length === deletePermissionSelectionCount"
                  (change)="onCheckboxChangeAll($event, false)"
                />
              </th>
              <th *ngFor="let col of columns">
                {{ col.header }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
            <tr>
              <td>
                <input
                  type="checkbox"
                  [checked]="!!deletePermissionSelection[rowData.key.toString()]"
                  (change)="onCheckboxChange($event, rowData.key, false)"
                />
              </td>
              <td *ngFor="let col of columns" width="30px">
                <clr-icon shape="times"></clr-icon>
                <label *ngIf="!col.type">{{ rowData[col.field] }}</label>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </kpd-collapse-panel>
      <kpd-collapse-panel
        title="{{ 'Permissions to add' | translate }}"
        *ngIf="changedPermissions.add.length > 0"
        [collapsed]="false"
      >
        <p-table
          class="dialog__table"
          dataKey="key"
          [value]="changedPermissions.add"
          [responsive]="true"
          [columns]="verifyColumns"
        >
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" translate>No permissions found</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
              <col *ngFor="let col of columns" [style.width]="col.width" />
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th width="30px">
                <input
                  type="checkbox"
                  [checked]="changedPermissions.add.length === addPermissionSelectionCount"
                  (change)="onCheckboxChangeAll($event, true)"
                />
              </th>
              <th *ngFor="let col of columns">
                {{ col.header }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
            <tr>
              <td>
                <input
                  type="checkbox"
                  [checked]="!!addPermissionSelection[rowData.key.toString()]"
                  (change)="onCheckboxChange($event, rowData, true)"
                />
              </td>
              <td *ngFor="let col of columns" width="30px">
                <clr-icon shape="plus"></clr-icon>
                <label *ngIf="!col.type">{{ rowData[col.field] }}</label>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </kpd-collapse-panel>
      <ng-template kpdTemplate="footer">
        <button
          class="button button--outline"
          (click)="close()"
          *ngIf="changedPermissions.delete.length === 0 && changedPermissions.add.length === 0"
          translate
        >
          Close
        </button>
        <button
          class="button button--outline"
          (click)="close()"
          *ngIf="changedPermissions.delete.length !== 0 || changedPermissions.add.length !== 0"
          translate
        >
          Cancel
        </button>
        <button
          class="button button--main"
          (click)="importPermissions()"
          [disabled]="addPermissionSelectionCount === 0 && deletePermissionSelectionCount === 0"
          *ngIf="changedPermissions.delete.length !== 0 || changedPermissions.add.length !== 0"
          translate
        >
          Import
        </button>
      </ng-template>
    </kpd-wizard-step>
    <kpd-wizard-step
      [header]="'Import' | translate"
      [success]="!importLoading && allSucceed"
      [error]="!importLoading && !allSucceed"
    >
      <div class="permissionset-import full-height">
        <div class="spinner__icon">
          <kpd-spinner type="inline" *ngIf="importLoading"></kpd-spinner>
          <clr-icon *ngIf="!importLoading && allSucceed" shape="check"></clr-icon>
          <clr-icon *ngIf="!importLoading && !allSucceed" shape="times"></clr-icon>
        </div>
        <h3 class="spinner__message">
          <span *ngIf="importLoading"
            ><span translate>Import</span> {{ feedback.length + 1 }} <span translate>of</span>
            {{ addPermissionSelectionCount + deletePermissionSelectionCount }} ...</span
          >
          <span *ngIf="!importLoading && allSucceed" translate>Import successful</span>
          <span *ngIf="!importLoading && !allSucceed"
            ><span translate>Import failed for</span> {{ feedback.length }} <span translate>items</span></span
          >
        </h3>
        <div class="spinner__feedback" #feedbackScroll>
          <span *ngFor="let item of sortedFeedback" class="spinner__feedback-item">
            <clr-icon [attr.shape]="item.success ? 'check' : 'times'"></clr-icon>
            &nbsp;
            <b>{{ (item.type === 'add' ? 'Add' : 'Delete') | translate }}:</b>
            {{ item.name }}
            <div class="spinner__feedback-error" *ngIf="!item.success">
              <clr-icon shape="error-standard"></clr-icon>
              &nbsp;
              {{ item.message }}
            </div>
          </span>
        </div>
        <ng-template kpdTemplate="footer">
          <button class="button button--main" [disabled]="importLoading" (click)="close(true)" translate>
            Finish
          </button>
        </ng-template>
      </div>
    </kpd-wizard-step>
  </kpd-wizard>
</p-dialog>
